const i18n = {
  'en-US': {
    'login.form.title': 'Login to Zhizaoband',
    'login.form.subtitle': 'Let the AI agent assist you in manufacturing',
    'login.form.identifier.errMsg': 'Account must be a phone or email',
    'login.form.password.errMsg': 'Password cannot be empty',
    'login.form.login.errMsg': 'Login error, please refresh and try again',
    'login.form.identifier.placeholder': 'Please enter phone or email',
    'login.form.password.placeholder': 'Please enter password',
    'login.form.rememberPassword': 'Remember password',
    'login.form.forgetPassword': 'Forgot password',
    'login.form.login': 'Login',
    'login.form.register': 'Register account',
    'login.form.corp.select': 'Please select your company to login',
    'login.form.verifyCode.errMsg': '验证码必须为6位数字',
    'login.form.verifyCode.placeholder': '请输入短信验证码',
    'login.form.getVerifyCode': '获取验证码',
    'login.form.getVerifyCode.errMsg': '获取验证码出错，请刷新重试',
    'login.form.verify.subtitle': '检测到异常登录风险，请输入短信验证码完成身份验证'
  },
  'zh-CN': {
    'login.form.title': '登录智造帮',
    'login.form.subtitle': '让智能体协助您智能制造',
    'login.form.identifier.errMsg': '账号必须为手机号码或者邮箱地址',
    'login.form.password.errMsg': '密码不能为空',
    'login.form.login.errMsg': '登录出错，请刷新重试',
    'login.form.identifier.placeholder': '请输入手机号码或者邮箱地址',
    'login.form.password.placeholder': '请输入密码',
    'login.form.rememberPassword': '记住密码',
    'login.form.forgetPassword': '忘记密码',
    'login.form.login': '登录',
    'login.form.register': '注册账号',
    'login.form.corp.select': '请选择一个企业登录',
    'login.form.verifyCode.errMsg': '验证码必须为6位数字',
    'login.form.verifyCode.placeholder': '请输入短信验证码',
    'login.form.getVerifyCode': '获取验证码',
    'login.form.getVerifyCode.errMsg': '获取验证码出错，请刷新重试',
    'login.form.verify.subtitle': '检测到异常登录风险，请输入短信验证码完成身份验证'
  }
};
export default i18n;